import { Box, Typography, useTheme } from '@mui/material';
import { useState, type JSX } from 'react';

type NativeLoginHeaderProps = {
    name: string;
    logoUrl: string;
    hasLogo: boolean;
    subtitle: string;
};

// Dumb brand block for the auth modal: tenant logo (with graceful fallback to name-only if
// the image fails to load), the tenant name, and a mode-specific subtitle. boxSizing is
// explicit because the widget shadow root has no CssBaseline (divs default to content-box).
export default function NativeLoginHeader({
    name,
    logoUrl,
    hasLogo,
    subtitle,
}: NativeLoginHeaderProps): JSX.Element {
    const theme = useTheme();
    const [imgFailed, setImgFailed] = useState(false);
    const showLogo = hasLogo && !imgFailed;

    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: theme.spacing(1),
            }}
        >
            {showLogo && (
                <Box
                    component="img"
                    src={logoUrl}
                    alt={name}
                    onError={() => setImgFailed(true)}
                    sx={{ maxHeight: 48, maxWidth: '70%', objectFit: 'contain' }}
                />
            )}
            {name && <Typography variant="h3">{name}</Typography>}
            {subtitle && (
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
}
